/* eslint-disable */
import irelandApi from '../irelandApi';

export const getAdminLinks = id => (dispatch) => {
  dispatch({type: 'GET_ADMIN_LINKS_PENDING', payload: []});

  return irelandApi.get(`/api/navigation_links`)
    .then((response) => {
      let payload = response.data ? response.data : {data: false};
      dispatch({type: 'GET_ADMIN_LINKS_FULFILLED', payLoad: payload});      
    })
    .catch((error) => {
      dispatch({type: 'GET_ADMIN_LINKS_REJECTED', payLoad: error});
    });
};
